import { render, staticRenderFns } from "./UserLeaveForm.vue?vue&type=template&id=a1e6e762"
import script from "./UserLeaveForm.vue?vue&type=script&lang=js"
export * from "./UserLeaveForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports